import { useEffect, useState } from 'react';

import { LoadingScreen } from 'src/components/common/loaders';
import { useIsMClassUserCheck } from 'src/hooks/use-is-mclass-user-check';
import { useSelfSignupUserCheck } from 'src/hooks/use-self-signup-user-check.hook';
import { useUserAssets } from 'src/hooks/use-user-assets.hook';
import { Asset } from 'src/interfaces/assets.types';
import { getMSAppsSectionAssets } from 'src/utils/assets.utils';

import { AppsSectionItem } from './apps-section-item';
import { useGradesForFiltering } from './hooks/use-grades-for-filtering';

import './apps-section.scss';

export const AppsSection = () => {
  const [appsSectionAssets, setAppsSectionAssets] = useState<Asset[]>([]);

  const { data: userAssets, isLoadingWithoutError } = useUserAssets();
  const isSelfSignupUser = useSelfSignupUserCheck();
  const { isLoading: isMclassUserCheckLoading } = useIsMClassUserCheck();
  const gradesForFiltering = useGradesForFiltering();

  useEffect(() => {
    // For self-signup users, we should process even if no userAssets
    if (!userAssets?.length && !isSelfSignupUser) {
      return;
    }

    const assets = getMSAppsSectionAssets(
      userAssets ?? [],
      isSelfSignupUser ?? false,
      gradesForFiltering,
    );
    setAppsSectionAssets(assets);
  }, [userAssets, isSelfSignupUser, gradesForFiltering]);

  if (isLoadingWithoutError || isMclassUserCheckLoading) {
    return <LoadingScreen isTransparentVersion />;
  }

  return (
    <ul className="apps-section">
      {appsSectionAssets.map((asset) => {
        return <AppsSectionItem key={asset.businessKey} itemAsset={asset} />;
      })}
    </ul>
  );
};
